<template>
	<div id="home">
		<div class="banner">
			<!-- <img src="../assets/probanner1.png" alt=""> -->
			<video muted autoplay loop class="index-video" src="../assets/index/video.mp4"></video>
		</div>



		<!-- 翡翠行业四大痛点 -->
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					翡翠行业四大痛点
				</div>
				<div class="column-t2">
					PAIN POINT
				</div>
			</div>
			<div class="column-box clearfix">
				<div class="point-list wow bounceInLeft top__element" data-wow-delay="0.1s">
					<div class="point-title pl">
						<div class="text">
							交易<br>
							溯源
						</div>
					</div>
					<div class="point-content pr">
						<div class="text2">
							用区块链将源头证明司法确权，<br>
							专业设备多维度记录藏品特征数据
						</div>
					</div>
				</div>

				<div class="point-list wow bounceInRight top__element" data-wow-delay="0.3s">
					<div class="point-title pr">
						<div class="text">
							监守<br>
							自盗
						</div>
					</div>
					<div class="point-content pl">
						<div class="text2">
							RFID2.0技术，货物绑定标签后实现<br>
							防拆防盗，轨迹追踪、秒级报警
						</div>
					</div>
				</div>
				

				<div class="point-list wow bounceInLeft top__element" data-wow-delay="0.5s">
					<div class="point-title pl">
						<div class="text">
							运输<br>
							安全
						</div>
						
					</div>
					<div class="point-content pr">
						<div class="text2">
							军用材质材质外壳，人脸识别+物流<br>
							轨迹追踪，保护高价值货物安全
						</div>
					</div>
				</div>
				<div class="point-list wow bounceInRight top__element" data-wow-delay="0.7s">
					<div class="point-title pr">
						<div class="text">
							货源<br>
							共享
						</div>
					</div>
					<div class="point-content pl">
						<div class="text2">
							支持仓储型销售模式，实现共享货源，<br>
							让别人帮你卖货。
						</div>
					</div>
				</div>
			</div>	
		</div>	
		<!-- end -->



		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					平台优势
				</div>
				<div class="column-t2">
					ADVANTAGE
				</div>
			</div>
			<div class="column-box clearfix">
				<div class="contrast-box">
					<div class="contrast-left wow bounceInLeft top__element">
						<div class="contrast-title">
							同类竞品
						</div>
						<div class="contrast-content">
							<div class="c-c-content">
								<div>
									1.溯源产品
								</div>
								<div>
									2.物联监管平台
								</div>
								<div>
									3.智能保险箱
								</div>
							</div>	
						</div>
					</div>
					<div class="contrast-right wow bounceInRight top__element">
						<div class="contrast-title">
							物联云平台
						</div>
						<div class="contrast-content">
							<div class="c-c-title">
								平台优势尽显
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-content">
								<div class="c-list">
									整合
									<span class="c-c-text">
										溯源产品、
									</span>
								</div>
								<div class="c-c-text c-list">
									物联监管、智能保险箱
								</div>
								<div class="c-list">
									等一体化物联服务
								</div>
							</div>
						</div>
					</div>
					<div class="contrast-center">
						<img src="../assets/index/vs.png" alt="">
					</div>
				</div>
				<div class="superiority-wrap">
					<div class="superiority-bg wow bounceIn top__element" data-wow-delay="0.1s">
						<img src="../assets/index/middle.png" alt="">
					</div>
					<div class="superiority-list y1 wow bounceIn top__element" data-wow-delay="0.3s">
						<img src="../assets/index/ys1.png" alt="">
					</div>
					<div class="superiority-list y2 wow bounceIn top__element" data-wow-delay="0.6s">
						<img src="../assets/index/ys2.png" alt="">
					</div>
					<div class="superiority-list y3 wow bounceIn top__element" data-wow-delay="1.2s">
						<img src="../assets/index/ys3.png" alt="">
					</div>
					<div class="superiority-list y4 wow bounceIn top__element" data-wow-delay="1.5s">
						<img src="../assets/index/ys4.png" alt="">
					</div>
					<div class="superiority-list y5 wow bounceIn top__element" data-wow-delay="1.8s">
						<img src="../assets/index/ys5.png" alt="">
					</div>
					<div class="superiority-list y6 wow bounceIn top__element" data-wow-delay="2.1s">
						<img src="../assets/index/ys6.png" alt="">
					</div>
					
					<div class="superiority-list y7 wow bounceIn top__element" data-wow-delay="2.4s">
						<img src="../assets/index/ys7.png" alt="">
					</div>
				</div>

			</div>	
		</div>	



		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					适用场景
				</div>
				<div class="column-t2">
					SCENARIO
				</div>
			</div>
			<div class="column-box clearfix">

				<div class="man-header clearfix">
					<div class="man-list fl" :class="index==activeIndex?'active':''" v-for="(i,index) in list" :key="index" @click="onSwiper(index)">
						{{i.name}}
					</div>
				</div>
				<div class="man-custom">
					<swiper class="man-swiper" :options="swiperOption2" ref="mySwiper" style="width: 85%;" @slideChange="slideChange">
						<swiper-slide class="swiper-list" v-for="(i,index) in list" :key="index">
							<img :src="i.imgUrl">
							<p class="l1">{{i.name}}</p>
						</swiper-slide>
					</swiper>

				</div>


			</div>	
		</div>









		
<div data-aos="fade-up" data-aos-offset="200">14561456</div>

		



	</div>
</template>
<script>
import banner from './banner.vue';
export default{
	name: 'App',
	data(){
		return{
			activeIndex: 0,
			swiperOption2:{
				slidesPerView: 2,
				loop: false,
				spaceBetween: 30,
				centeredSlides: true,
				navigation: {
					nextEl: '.swiper-button-next2',
					prevEl: '.swiper-button-prev2',
				}
			},
			list: [
				{
					imgUrl: require('@/assets/index/i2.jpg'),
					name: '零售店铺',
					id: 1
				},
				{
					imgUrl: require('@/assets/index/i3.jpg'),
					name: '展厅',
					id: 2
				},
				{
					imgUrl: require('@/assets/index/i4.jpg'),
					name: '仓储型卖场',
					id: 3
				},
				{
					imgUrl: require('@/assets/index/i1.jpg'),
					name: '公司资产管理',
					id: 4
				}
			]




		}
	},
	components:{
		'v-banner': banner
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		}
	},
	methods:{

		// 
		// 你也可以在这里设置全局配置
		// AOS.init({
		// 	offset: 200,   
		// 	duration: 600,   //持续时间
		// 	easing: 'ease-in-sine',   
		// 	delay: 100
		// })
		onSwiper(index){
			this.swiper.slideTo(index, 1000, false);
		},
		slideChange(){
			// console.log(this.$refs.mySwiper.swiper.activeIndex)
			this.activeIndex = this.$refs.mySwiper.swiper.activeIndex
		}
	},
}
</script>
<style scoped>
	@import url("../resource/css/index.css");
  .animate{
    transition: all 2s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue